/* eslint-disable no-console -- log level filtering is intentional */

import { LogLevel } from '@azure/msal-browser';
import { getOAuthSettings } from './getOAuthSettings';

const settings = getOAuthSettings();

export const msalConfig = {
  auth: {
    clientId: settings.microsoftClientId,
    authority: settings.microsoftAuthority,
    redirectUri: settings.microsoftRedirectUri,
    postLogoutRedirectUri: settings.microsoftPostLogoutRedirectUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    // MFA / number matching in the popup can take longer than msal-browser's 60 s default (#765).
    popupBridgeTimeout: 300000,
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string | undefined,
        containsPii: boolean,
      ): void => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Trace:
            return;
        }
      },
    },
  },
};

export const microsoftLoginRequest = {
  scopes: settings.microsoftScopes,
};

export const microsoftLogoutRequest = {
  postLogoutRedirectUri: settings.microsoftPostLogoutRedirectUri,
};
